/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Questions/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import CbsComplete from './CbsComplete/index'
import Complete from './Complete/index'
import Question from './Question/index'
import React from 'react'
import Review from './Review/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Questions({
  children,
  viewPath = "/App/Widget/Content/Questions"
  
}) {
  let isBefore = useIsBefore()
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Question'
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
  return (<React.Fragment
>
<div
  data-testid="Questions.Vertical"
  data-view-path={viewPath}
 style={{'--pl-2-g0REU': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-3-g0REU': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-4-g0REU': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pt-5-g0REU': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--o-1-g0REU': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<fromFlow.When is={flowValue === 'Question'}>
<Question
  viewPath={`${viewPath}/Question`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Review'}>
<Review
  viewPath={`${viewPath}/Review`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Complete'}>
<Complete
  viewPath={`${viewPath}/Complete`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CbsComplete'}>
<CbsComplete
  viewPath={`${viewPath}/CbsComplete`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}